exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ntr.is-info {\n        background: #167df0;\n        color: #fff;\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/table/examples/ExRowStatus.vue"],"names":[],"mappings":";AACA;QACQ,oBAAoB;QACpB,YAAY;CACnB","file":"ExRowStatus.vue","sourcesContent":["\ntr.is-info {\n        background: #167df0;\n        color: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71797d86","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./docs/pages/components/table/examples/ExRowStatus.vue
// module id = 1215
// module chunks = 1 46